import { useContext } from 'react';
import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { ANY_SPORT_MY_CLUB_SLUG_CARDS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MyClubCardsLayoutContext } from '#src/layouts/my-cards/MyClubCardsLayout/MyClubCardsLayoutContext.tsx';

export const MyClubCardsPage = <Params extends { slug: string }>() => {
  const { generateSportContextPath } = useSportContext();
  const { defaultRarity } = useContext(MyClubCardsLayoutContext);
  const { slug } = useTypedParams<Params>();
  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_MY_CLUB_SLUG_CARDS_TYPE, {
        params: { slug, type: defaultRarity },
      })}
    />
  );
};
